// @flow
export default {
  onSSO:
    'All AM should be created in the company before being able to login using SSO',
  offSSO: 'All AM will have to login using his Leap username and password',
  companies: 'Companies',
  addCompany: 'Add Company',
  companyName: 'Company Name',
  sso: 'SSO',
  whatsappNative: 'Whatsapp Native',
  location: 'Location',
  accountManagers: 'Account Managers',
  accountManager: 'Account Manager',
  dateRegistered: 'Date registered',
  addAccountManager: 'Add Account Manager',
  addClient: 'Add Client',
  name: 'Name',
  email: 'Email',
  phoneNumber: 'Phone Number',
  clients: 'Clients',
  userType: 'User Type',
  company: 'Company',
  logout: 'Logout',
  backToCompanies: 'Back to Companies List',
  backtoAMs: 'Back to Companies List',
  leapXpertAdmin: 'LeapXpert Admin',
  logoutConfirm: 'Are you sure you want to logout?',
  cancel: 'Cancel',
  editAm: 'Edit Account Manager',
  firstName: 'First Name',
  lastName: 'Last Name',
  role: 'Role',
  selectRole: 'Select Role',
  temporaryPassword: 'Temporary Password',
  newPassword: 'New Password',
  save: 'Save',
  editCompany: 'Edit Company',
  inviteSent: 'INVITE SENT!',
  inviteMessage: 'An invitation was sent to',
  done: 'Done',
  success: 'SUCCESS!',
  addCompanySuccessMessage: 'has been added Successfully',
  username: 'User name',
  error: 'Something wrong, please try again!',
  changesSaved: 'Changes Saved',
  loginName: 'Login Name',
  logo: 'Primary Logo',
  logoLogin: 'Logo in login screens',
  '2faWecomBanner': 'Banner',
  upload: 'Upload',
  uploadLogoError: {
    error1: 'File size must be smaller than 2MB',
    error2: 'Updating profile failed, please try again.'
  }
}
